<template>
    <div id="app" class="d-flex flex-column min-vh-100">
        <loch-navbar></loch-navbar>
        <a class="skip-main" href="#main">Skip to main content</a>

        <div class="bg-breadcrumb">
            <div v-if="showBreadcrumbs && this.$route.meta.breadcrumb" class="breadcrumb-container container">
                <div class="row">
                    <div class="col text-left">
                        <bread-crumb></bread-crumb>
                    </div>
                </div>
            </div>
        </div>

        <!-- Main Content -->
        <div class="flex-grow-1">
            <router-view :key="$route.fullPath"></router-view>
        </div>

        <!-- Need Help Section -->
        <div class="mt-5 bg-white" v-if="showNeedHelp">
            <div>
                <NeedHelp></NeedHelp>
            </div>
        </div>

        <!-- Footer -->
        <footer class="mt-auto">
                <SeeUpdatesFooter v-if="showUpdatesFooter"></SeeUpdatesFooter>
                <MainFooter></MainFooter>
                <cookie-law buttonText="Accept Cookies">
                    <div slot="message">
                        This website uses cookies to ensure you get the best experience, for more information
                        <router-link class="router-link" :to="{ name: 'Cookie' }">Click Here</router-link>
                    </div>
                </cookie-law>
                <CampaignModal v-if="activeCampaign && canAppear($route.name)" :active-campaign="activeCampaign"/>
        </footer>
    </div>
</template>

<script>
import SeeUpdatesFooter from '@/components/SeeUpdatesFooter.vue'
import LochNavbar from 'navbar/LochNavbar.vue'
import BreadCrumb from '@/components/Breadcrumb.vue'
import CookieLaw from 'vue-cookie-law'
import MainFooter from 'footer/MainFooter.vue'
import moment from 'moment'
import NeedHelp from '@/components/NeedHelp.vue'
import CampaignModal from '@/components/CampaignModal.vue'
import { mapActions, mapState, mapGetters } from 'vuex'

const whitelabel = require('../whitelabel.config')[process.env.VUE_APP_BRAND]


export default {
    components: {
        SeeUpdatesFooter,
        LochNavbar,
        BreadCrumb,
        CookieLaw,
        CampaignModal,
        MainFooter,
        NeedHelp,


    },
    data() {
        return {
            icon: whitelabel.baseUrlIcon,
            name: whitelabel.title,
            footer: whitelabel.footerPath,
            email: whitelabel.contactEmail,
            support: whitelabel.support,
            showBreadcrumbs: whitelabel.showBreadcrumbs,
            showUpdatesFooter: whitelabel.showUpdatesFooter,
            showNeedHelp: whitelabel.showNeedHelp,
        }
    },
    created() {
        const icon = document.getElementById('icon-base')
        icon.href = this.icon
        document.title = this.name

        /* Authenticate User */
        this.authenticateUser()
        this.fetchActiveCampaign()
    },
    methods: {
        ...mapActions([
            'fetchAuthenticatedUser',
            'getActiveCampaign',
        ]),
        authenticateUser() {
            if (this.auth.token) {
                this.fetchAuthenticatedUser()
            }
        },
        clearOlderThanADay() {
            const dateToday = moment()
            const impressionsArray = this.campaignImpressions
            for (let i = 0; i < impressionsArray.length; i += 1) {
                if (moment(impressionsArray[i].expires_at).add(1, 'days').isBefore(dateToday)) {
                    this.campaignImpressions.splice(i, 1)
                }
            }
        },

        fetchActiveCampaign() {
            this.clearOlderThanADay()
            this.getActiveCampaign({
                params: {
                    order_by: 'end_at',
                    order: 'asc',
                    per_page: 1,
                    impression_ids: this.campaignImpressionIds,
                },
            })
        },
        canAppear(currentRouteName) {
            if (this.activeCampaign.appear_on === 'journey-planner' && currentRouteName === 'Home') {
                return true
            } if (this.activeCampaign.appear_on === 'journey-results' && currentRouteName === 'Results') {
                return true
            } if (this.activeCampaign.appear_on === 'journey-details' && currentRouteName === 'Journey') {
                return true
            } if (this.activeCampaign.appear_on === 'account-register' && (currentRouteName === 'Register' || currentRouteName === 'Account')) {
                return true
            }
            return false
        },
    },
    computed: {
        ...mapState([
            'auth',
            'activeCampaign',
            'campaignImpressions',
        ]),
        ...mapGetters([
            'campaignImpressionIds',
        ]),
    },
}
</script>

<style lang="scss">
#app {
    font-family: 'PT Sans', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
}

#nav {
    padding: 30px;

    a {
        font-weight: bold;
        color: #2c3e50;

        &.router-link-exact-active {
            color: #42b983;
        }
    }
}

</style>
